import { Button, Divider, Stack, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { genericMessages, singleMessages } from 'utils/global-messages';

export interface FormData {
  email: string;
}

interface LoginFormProps {
  onSubmit: () => Promise<void>;
  formError?: string;
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const LoginForm: FC<LoginFormProps> = ({ onSubmit, formError }) => {
  const { formatMessage } = useIntl();

  const {
    register,
    formState: { errors, isSubmitting },
  } = useFormContext<FormData>();

  return (
    <Stack component="form" spacing={4} onSubmit={onSubmit} sx={{ width: '100%' }}>
      <Divider />

      <Typography variant="body1" fontWeight={'bold'} textAlign="center">
        Sign in
      </Typography>

      {formError && <Typography variant="body2">{formError}</Typography>}

      <StyledTextField
        label={formatMessage(singleMessages.email)}
        id={formatMessage(singleMessages.email).replace(/\s/g, '-')}
        variant="outlined"
        fullWidth
        disabled={isSubmitting}
        type="email"
        error={!!errors.email}
        helperText={
          errors.email?.type === 'required' ? formatMessage(genericMessages.fieldRequired) : ''
        }
        inputProps={{
          'aria-invalid': errors.email ? 'true' : 'false',
        }}
        {...register('email', { required: true })}
      />
      <Button type="submit" variant="contained" size="large" disabled={isSubmitting}>
        Continue
      </Button>
    </Stack>
  );
};
